import { css } from '@emotion/core';
import { theme } from '@weave/theme';

export const titleStyle = css`
  font-weight: ${theme.font.weight.bold};
`;
